import { Box } from '@chakra-ui/react';
import { DOCS_HEADER_HEIGHT } from '../layout/header';
import { SIDENAV_WIDTH } from '../layout/sidenav';

type Props = {
  children: React.ReactNode;
};

export function PageContainer({ children }: Props): JSX.Element {
  return (
    <Box
      as="main"
      pos="relative"
      pt={{ base: DOCS_HEADER_HEIGHT.base }}
      bg="var(--bodyBg)"
      minH={{ base: `calc(100vh - ${DOCS_HEADER_HEIGHT.base})` }}
      w={{ base: 'full', lg: `calc(100vw - ${SIDENAV_WIDTH})` }}
      left={{ base: 0, lg: SIDENAV_WIDTH }}
    >
      {children}
    </Box>
  );
}
